/**
 * lamejsWrapper.js — Load lamejs via script tag (bypasses webpack module scope)
 * 
 * lamejs's internal modules reference globals (MPEGMode, etc.) that webpack
 * cannot resolve when bundled as ES/CJS modules. The only reliable approach
 * is to load lame.all.js as a plain script, which executes in global scope.
 */

let loaded = false;
let loadPromise = null;

function loadLamejs() {
  if (loaded && window.lamejs) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    // Check if already loaded
    if (window.lamejs && window.lamejs.Mp3Encoder) {
      loaded = true;
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = '/lamejs.js';
    script.onload = () => {
      // lame.all.js calls lamejs() at the end, which sets lamejs.Mp3Encoder
      if (window.lamejs && window.lamejs.Mp3Encoder) {
        loaded = true;
        resolve();
      } else {
        reject(new Error('lamejs loaded but Mp3Encoder not found'));
      }
    };
    script.onerror = () => reject(new Error('Failed to load lamejs.js'));
    document.head.appendChild(script);
  });

  return loadPromise;
}

export async function createMp3Encoder(channels, samplerate, kbps) {
  await loadLamejs();
  return new window.lamejs.Mp3Encoder(channels, samplerate, kbps);
}
